import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingActionButton from '../../common/petCloud/LoadingActionButton';

import addIcon from '../../../assets/policy/add-white.svg';

import styles from './Reimbursement.module.css';

export const AddReimbursementMethod = ({
  isRedirectAvailable = false,
  onReimbursementMethod = () => { },
}) => {
  const { t } = useTranslation('insurance');

  return (
    <div className={styles.reimbursementMethodCard}>
      <span className={styles.reimbursementMethodText}>
        {`${t('noReimbursementMethod')} ${isRedirectAvailable
          ? t('addMethod')
          : ''}`}
      </span>

      {isRedirectAvailable && (
        <LoadingActionButton
          className={styles.reimbursementMethodAddButton}
          onClick={onReimbursementMethod}
          type="button"
        >
          <img alt="" src={addIcon} />

          <span>{t('addReimbursementMethod')}</span>
        </LoadingActionButton>
      )}
    </div>
  );
};
